const defaultBaseDecimalSystem = 10;
export default defaultBaseDecimalSystem;
